
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#ffffff",
        "d": "M725.333333 426.666667c82.474667 0 149.333333 64.981333 149.333334 145.130666l-0.106667 5.12c-1.834667 47.957333-29.12 101.888-73.898667 156.586667a630.357333 630.357333 0 0 1-52.650666 56.576l-9.024 8.448-8.234667 7.36c-2.410667 2.133333-4.266667 3.690667-5.418667 4.650667l-5.418666-4.650667-8.234667-7.36a630.357333 630.357333 0 0 1-61.674667-65.024c-44.8-54.698667-72.064-108.629333-73.898666-156.586667l-0.106667-5.12C576 491.648 642.858667 426.666667 725.333333 426.666667z m64-256a64 64 0 0 1 64 64v149.333333h-64v-149.333333H234.666667v448h298.666666v64H234.666667a64 64 0 0 1-64-64V234.666667a64 64 0 0 1 64-64h554.666666z m-64 320c-46.037333 0-82.965333 34.474667-85.226666 76.992l-0.106667 4.138666 0.042667 2.645334c1.173333 30.186667 21.077333 71.616 59.477333 118.506666 5.418667 6.613333 11.072 13.162667 16.917333 19.626667l8.896 9.642667 8.896-9.642667c5.845333-6.464 11.52-13.013333 16.917334-19.626667 36.714667-44.842667 56.533333-84.693333 59.2-114.496l0.277333-4.010666 0.042667-2.645334C810.666667 527.424 772.864 490.666667 725.333333 490.666667z m0 42.666666a42.666667 42.666667 0 1 1 0 85.333334 42.666667 42.666667 0 0 1 0-85.333334z m-256-85.333333v64h-192v-64h192z m170.666667-128v64H277.333333v-64h362.666667z"
      }
    }
  ]
})
    }
  